import * as React from 'react';
import { toast, Button } from '@grandvisionhq/common';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { pushTryOnInStoreEvent } from '../../data-layer/try-on-in-store.js';
import { useTryInStore } from '../../hooks/use-try-in-store.js';
import '@swc/helpers';
import '../../context/context.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import { SelectionModal } from '../../modules/SelectionModal/SelectionModal.js';

const AddButtonComponent = ({ slug , sku  })=>{
    const { getLabel  } = useIntl();
    const [showModal, setShowModal] = React.useState(false);
    const [{ products , itemCount  }, { storage  }] = useTryInStore();
    const onCloseModal = React.useCallback(()=>{
        setShowModal(false);
    }, [
        setShowModal
    ]);
    const onAddItems = React.useCallback(()=>{
        pushTryOnInStoreEvent({
            interactionType: 'add_product'
        });
        if (products === null || products === void 0 ? void 0 : products.find((product)=>product.sku === sku
        )) {
            setShowModal(true);
        } else if (itemCount === 3) {
            toast.warning('products.reserveInStore.warning.message');
        } else {
            storage.add({
                slug,
                sku
            });
            setShowModal(true);
        }
    }, [
        itemCount,
        products,
        sku,
        slug,
        storage
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, {
        className: "try-in-store__button",
        variant: "ghost",
        size: "large",
        icon: "store",
        caption: getLabel('products.actions.reserveInStore'),
        onClick: onAddItems
    }), showModal ? /*#__PURE__*/ React.createElement(SelectionModal, {
        onModalClose: onCloseModal
    }) : null);
};
const AddButton = ({ slug , sku , isReservable  })=>{
    const { isTryInStoreEnabled  } = useFeatureToggles();
    if (isTryInStoreEnabled && isReservable) {
        return /*#__PURE__*/ React.createElement(AddButtonComponent, {
            slug: slug,
            sku: sku
        });
    }
    return null;
};

export { AddButton };
//# sourceMappingURL=AddButton.js.map
